const tmall = resolve => require(['@/view/union/tao/tmall'], resolve)
const taobao = resolve => require(['@/view/union/tao/taobao'], resolve)
const juhuasuan = resolve => require(['@/view/union/tao/juhuasuan'], resolve)
const taoCate2List = resolve => require(['@/view/union/tao/taoCate2List'], resolve)
const taoDetail = resolve => require(['@/view/union/tao/taoDetail'], resolve)
const taoOauth = resolve => require(['@/view/union/tao/taoOauth'], resolve)
const jdIndex = resolve => require(['@/view/union/jd/index'], resolve)
const jdCateList = resolve => require(['@/view/union/jd/cateList'], resolve)
const jdDetail=resolve=>require(['../view/union/jd/jdDetail'],resolve)
const pddIndex = resolve => require(['@/view/union/pdd/index'], resolve)
const pddCateList= resolve => require(['@/view/union/pdd/cateList'], resolve)
const pddDetail = resolve => require(['@/view/union/pdd/pddDetail'], resolve)
const pddOauth = resolve => require(['@/view/union/pdd/pddOauth'], resolve)

const routes = [
  {
    path: '/union/tao/tmall',
    name: '/union/tao/tmall',
    component: tmall,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/union/tao/taobao',
    name: '/union/tao/taobao',
    component: taobao,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/tao/juhuasuan',
    name: '/union/tao/juhuasuan',
    component: juhuasuan,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/tao/taoCate2List',
    name: '/union/tao/taoCate2List',
    component: taoCate2List,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/tao/taoDetail',
    name: '/union/tao/taoDetail',
    component: taoDetail,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/tao/taoOauth',
    name: '/union/tao/taoOauth',
    component: taoOauth,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/jd/index',
    name: '/union/jd/index',
    component: jdIndex,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/jd/cateList',
    name: '/union/jd/cateList',
    component: jdCateList,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/jd/jdDetail',
    name: '/union/jd/jdDetail',
    component: jdDetail,
    meta: {
    }
  },{
    path: '/union/pdd/index',
    name: '/union/pdd/index',
    component: pddIndex,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/pdd/cateList',
    name: '/union/pdd/cateList',
    component: pddCateList,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/pdd/pddDetail',
    name: '/union/pdd/pddDetail',
    component: pddDetail,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/union/pdd/pddOauth',
    name: '/union/pdd/pddOauth',
    component: pddOauth,
    meta: {
      // requireAuth: true
    }
  },]
export default {routes}



// WEBPACK FOOTER //
// ./src/router/union.js